import { InviteMembers } from '@/features/invites/components/invite-members';
import { useAuth } from '@/hooks/auth/use-auth';
import { Button } from '@/shared/components/ui/button';
import { MembershipRole } from '@/types/api/membership';
import { Lock, RotateCw, TriangleAlert } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

export function AgeVerificationRequired({ showReloadAlert }: { showReloadAlert: boolean }) {
  const { pathname } = useLocation();
  const { context } = useAuth();

  return (
    <section className="grow p-6 mb-5 space-y-6">
      {showReloadAlert && <ReloadAlert />}
      <h2 className="text-2xl text-gray-800 dark:text-gray-100 font-bold mb-2 flex items-center gap-2">
        <Lock />
        Verifiering krävs
      </h2>

      <p className="text-sm">För att hantera utbetalningskonto behöver du först verifiera dig med BankID.</p>

      <div className="flex flex-col md:flex-row gap-2">
        <Button asChild>
          <Link to={`/auth/bankid?redirect=${pathname}`}>Verifiera med BankID</Link>
        </Button>
        <InviteMembers
          roles={[MembershipRole.Leader, MembershipRole.Member]}
          orgId={context!.groupId}
          variant={'outline'}
        >
          Under 18? Bjud in myndig ledare
        </InviteMembers>
      </div>

      <p className="text-sm">Detta är för din säkerhet och för att följa gällande regler.</p>
    </section>
  );
}

export function ReloadAlert() {
  return (
    <div className="rounded-md border px-4 py-3">
      <div className="flex gap-3">
        <TriangleAlert className="hrink-0 mt-0.5 text-amber-500" size={16} aria-hidden="true" />
        <div className="flex grow justify-between gap-3">
          <p className="text-sm">Precis verifierat?</p>
          <button onClick={() => location.reload()} className="group text-sm font-medium whitespace-nowrap">
            Ladda om
            <RotateCw
              className="ms-1 -mt-0.5 inline-flex opacity-60 transition-transform duration-200 group-hover:rotate-45"
              size={16}
              aria-hidden="true"
            />
          </button>
        </div>
      </div>
    </div>
  );
}
